// extracted by mini-css-extract-plugin
export default {"browse-block":"styles_browse-block__ON3DU"};